import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared presentational component for the generic status/error pages
 * (401 / 403 / 404 / 500). Themed via the global design tokens — no hard-coded
 * colours. Each concrete status page supplies its code, title, message, and icon.
 */
export default function StatusPage({ code, title, message, icon = 'fa-triangle-exclamation' }) {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center px-3"
      style={{ minHeight: 'calc(100vh - 220px)' }}
    >
      <i className={`fa-solid ${icon} text-primary mb-3`} style={{ fontSize: '3.5rem' }} aria-hidden="true" />
      <h1 className="display-4 fw-bold mb-2" style={{ color: 'var(--primary-color)' }}>
        {code}
      </h1>
      <h2 className="h4 mb-3">{title}</h2>
      <p className="text-muted mb-4" style={{ maxWidth: 480 }}>
        {message}
      </p>
      <div className="d-flex gap-2">
        <Link to="/" className="btn btn-primary">
          <i className="fa fa-home me-1" aria-hidden="true" />
          Go to Home
        </Link>
        <Link to="/login" className="btn btn-outline-secondary">
          <i className="fa fa-sign-in-alt me-1" aria-hidden="true" />
          Sign in
        </Link>
      </div>
    </div>
  );
}
